import axios from "axios"

class Api {
  constructor() {
    this.cookies = {
      PROPERTIES: 1010,
      PROPERTY: 1011,
      POWER: 1012,
      GUEST: 1013,
      SOURCE: 1014,
      APPS: 1015,
      APP: 1016,
      USERINPUTS: 1017,
      PLAY: 1030,
      STOP: 1031,
      AUDIO: 1032,
      SUBTITLE: 1033,
      STATUS: 1034
    }
  }

  _init = async () => {
    window.actionTimeout = 60000
    document.getElementById("viewport").setAttribute("content", "width=1280, initial-scale=1.5, user-scalable=no")

    await this.loadResources()
    await _$.sleep(2000)
    await this.makeConfigurations()

    this.addListeners()
    _$.vue.$once("platformInit", () => this.setServerConfiguration())
    return true
  }

  addListeners = () => {
    document.addEventListener(
      "OnKeyReceived",
      event => {
        const detail = event.detail.split(",")
        const type = parseInt(detail.pop())
        const code = detail.pop()

        if (code == window.VK_MENU && !__.source.isPlatformSource()) __._source.set("None").then(res => !res && __._source.set("MainTuner"))
        else if (code == window.VK_MENU && !__.platform.focus) __._app.close()
        else _$.nav[type ? "onKeyUp" : "onKeyDown"]({ keyCode: code })
      },
      false
    )
    wixpObject.WebIXPOnReceive = this._eventHandler

    _$.vue.$on("mediaPlaying", () => !__.device.isPowerOn() && __.media.stop().then(() => __.media.request(true)))

    _$.vue.$on("standBy", () => __.platform.go().then(res => !res && __.media.request(true)))
    _$.vue.$on("powerOn", () => __.media.request())

    wixpObject.WebIXPOnReceiveRawData = this.WIXPCallbackRawDataReceived

    var RawData = "heartbeat"
    var RawDataLength = RawData.length

    wixpObject.WebIXPSendRawData(RawData, RawDataLength)
    setInterval(() => {
      wixpObject.WebIXPSendRawData(RawData, RawDataLength)
    }, 6000)
  }

  WIXPCallbackRawDataReceived = RawData => {
    try {
      _$.handler.emit("messageEvent", RawData)
    } catch (E) {
      console.log(E)
    }
  }

  makeConfigurations = async () => {
    var requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Change",
      Fun: "ProfessionalSettingsControl",
      CommandDetails: {
        RawWIXP: {
          Enable: "On",
          RawWIXPServerIP: "172.16.1.10",
          RawWIXPPort: 3004
        }
      }
    }
    __._api._sendCommand(requestObject_)

    return true
  }
  loadResources = async () => {
    _$.loader.createObject("object", {
      style: "visibility: hidden;",
      type: "application/jswebixp",
      width: "0",
      height: "0",
      id: "wixpObject"
    })
    return true
  }
  _eventHandler(WIXPResponseJSON) {
    try {
      console.log(WIXPResponseJSON)
      WIXPResponseJSON = JSON.parse(WIXPResponseJSON)

      const event_ = {
        error: WIXPResponseJSON.Fun === "Error",
        type: WIXPResponseJSON.Fun,
        cookie: WIXPResponseJSON.Cookie,
        detail: WIXPResponseJSON.Fun === "Error" ? WIXPResponseJSON.CommandDetails.FunCausedError : WIXPResponseJSON.CommandDetails
      }
      return _$.handler.emit(event_)
    } catch (e) {
      return _$.error(e)
    }
  }
  _sendCommand(command, Svc = "WIXP") {
    let command_ = {
      Svc: Svc,
      SvcVer: "4.7",
      Cookie: 222
    }

    command_ = Object.assign(command_, command)
    wixpObject.WebIxpSend(JSON.stringify(command_))
  }

  async setServerConfiguration() {
    const config = await axios
      .get(`${__.platform.baseUrl}/Api/philips/config.json`)
      .then(response => response.data)
      .catch(() => false)
    if (!config) throw "An error occured while getting Philips config from server"

    if (config.active) {
      let requestObject_ = {
        Cookie: __._api.cookies.PROPERTY,
        CmdType: "Change",
        Fun: "ProfessionalSettingsControl",
        CommandDetails: {
          SmartTVSettings: {
            SmartTVServerSettings: {
              SmartTVMode: "Profile",
              ProfileSettings: { AppControlID: config.appControlID, ProfileName: config.profileName, LocationID: config.locationID },
              SortAfterSync: "On"
            }
          }
        }
      }
      __._api._sendCommand(requestObject_)
    }
    return true
  }
  checkIn() {
    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Change",
      Fun: "PMS",
      CommandDetails: {
        PMSParameters: {
          Action: "CheckIn",
          RoomStatus: {
            Status: "Occupied"
          }
        }
      }
    }
    __._api._sendCommand(requestObject_)
  }
  checkOut() {
    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Change",
      Fun: "PMS",
      CommandDetails: {
        PMSParameters: {
          Action: "CheckOut",
          RoomStatus: {
            Status: "Vacant"
          }
        }
      }
    }
    __._api._sendCommand(requestObject_)
  }
}

export default Api
